import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTomorrowlandComponent } from './simple-icons-tomorrowland.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTomorrowlandComponent ],
    exports:      [ SimpleIconsTomorrowlandComponent ],
    bootstrap:    []
})
export class SimpleIconsTomorrowlandModule {}
